import { useSetState } from "components/ReduxProvider";
import { QuestCloseButton } from "./misc/QuestCloseButton";
import { QuestMessage } from "./misc/QuestMessage";
import { Quest } from "./Quest";
import { Trans } from "react-i18next";
import { OUTAGE_DAY } from "sharedJs__generated/constants";
import Flames from "components/fire/Flames";
import styled from "styled-components/macro";

const SFlames = styled(Flames)`
  display: inline-block;
  margin: 0 7px -7px 6px;
`;

export function OutageQuest() {
  const setOutage = useSetState("outage");

  return (
    <Quest questName="OutageQuest" requiredExps={0}>
      <QuestMessage>
        <Trans parent="div">I am sorry for yesterday's outage. It was caused by server issues.</Trans>
        <Trans parent="div">
          As an apology, you can recover your daily series and you only need <SFlames strength={4} xps={5} /> today.
        </Trans>
        <QuestCloseButton
          onClick={() => {
            setOutage(OUTAGE_DAY.toISOString());
          }}
        />
      </QuestMessage>
    </Quest>
  );
}
